/* tslint:disable */
/* eslint-disable */
/**
 * quarkus-betting API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.36.47
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RoundWinner
 */
export interface RoundWinner {
    /**
     * 
     * @type {number}
     * @memberof RoundWinner
     */
    userId: number;
    /**
     * 
     * @type {string}
     * @memberof RoundWinner
     */
    userName: string;
    /**
     * 
     * @type {string}
     * @memberof RoundWinner
     */
    email: string;
}

/**
 * Check if a given object implements the RoundWinner interface.
 */
export function instanceOfRoundWinner(value: object): value is RoundWinner {
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('userName' in value) || value['userName'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    return true;
}

export function RoundWinnerFromJSON(json: any): RoundWinner {
    return RoundWinnerFromJSONTyped(json, false);
}

export function RoundWinnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoundWinner {
    if (json == null) {
        return json;
    }
    return {
        
        'userId': json['userId'],
        'userName': json['userName'],
        'email': json['email'],
    };
}

export function RoundWinnerToJSON(value?: RoundWinner | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'userId': value['userId'],
        'userName': value['userName'],
        'email': value['email'],
    };
}

